import { setRoutesConfig } from './reducers';

export { setRoutesConfig };

export const SET_ROUTES_CONFIG = setRoutesConfig.type;
